import { Paper, TableContainer } from "@mui/material"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { useLocalization } from "@fluent/react"
import { enUS, plPL } from "@mui/x-data-grid/locales"
import { selectSettings } from "../../settings/settingsSlice"
import { unwrapResult } from "@reduxjs/toolkit"
import { LoadingContainer } from "../../../app/LoadingContainer"
import { loadReleaseNotificationHistory, ReleaseNotificationHistory } from "./ReleasesApi"

export const NotificationHistoryList = ({ id }: { id: number }) => {
    const { l10n } = useLocalization()
    const { locale } = useAppSelector(selectSettings);
    const dispatch = useAppDispatch();
    const [notificationHistory, setNotificationHistory] = useState<ReleaseNotificationHistory[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true);
        dispatch(loadReleaseNotificationHistory(id))
            .then(unwrapResult)
            .then(setNotificationHistory)
            .catch((error) => console.error(error))
            .finally(() => setIsLoading(false));
    }, [dispatch])

    const getCustomLocaleText = () => {
        const defaultEnLocaleText = enUS.components.MuiDataGrid.defaultProps.localeText;

        if (locale === 'pl') {
            return plPL.components.MuiDataGrid.defaultProps.localeText;
        } else {
            return defaultEnLocaleText;
        }
    };

    const columns: GridColDef<ReleaseNotificationHistory, any, any>[] = [
        {
            field: 'userName',
            headerName: l10n.getString("username", null, "_Nazwa użytkownika"),
            width: 300
        },
        {
            field: 'publishDate',
            headerName: l10n.getString("releases-publish-date", null, "_Data publikacji"),
            flex: 1,
            valueGetter: (_, row) => row.publishDate ? new Date(row.publishDate) : null,
            renderCell: (params) => params.row.publishDate ? new Date(params.row.publishDate).toLocaleString() : ""
        },
        {
            field: 'language',
            headerName: l10n.getString("releases-language", null, "_Język"),
            flex: 1,
        },
    ]

    if (isLoading) {
        return <>
            <LoadingContainer />
        </>
    }

    return (
        <>
            <TableContainer component={Paper}>
                <DataGrid localeText={getCustomLocaleText()}
                    style={{ minHeight: 100, height: 'calc(100vh - 450px)' }}
                    rows={notificationHistory}
                    columns={columns}
                    initialState={{
                        sorting: { sortModel: [{ field: 'eventDate', sort: 'desc' }] }
                    }}
                />
            </TableContainer>
        </>
    )
}
